import request from '@/utils/request'

export function page(params) {
  return request({
    url: '/api/business/contract/page',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/api/business/contract',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/api/business/contract',
    method: 'put',
    data
  })
}

export function batchDel(ids) {
  return request({
    url: '/api/business/contract/batch',
    method: 'delete',
    data: ids
  })
}

export function getById(id) {
  return request({
    url: '/api/business/contract',
    method: 'get',
    params: {
      id
    }
  })
}

export function markAsFormal(data) {
  return request({
    url: '/api/business/contract/markAsFormal',
    method: 'post',
    data
  })
}
